import React from "react";

const defaultUserObj = {
    name: 'guest',
    isAuthenticated: false,
    role: 'guest',
    permissionlevel: '',
    firstname: '',
    lastname: '',
    cellnumber: '',
    email:''
};

const UserLoggedInContext = React.createContext({
    userDetails: defaultUserObj,
    changeUser: () => {
    },
    refreshTokens:()=>{

    }
}
);

const UserLoggedInContextProvider = UserLoggedInContext.Provider;
const UserLoggedInContextConsumer = UserLoggedInContext.Consumer;
export { UserLoggedInContext as default, defaultUserObj, UserLoggedInContextProvider, UserLoggedInContextConsumer};
